import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m20.4 19.5-15-15m4.8 5.942c-.373.411-.6.952-.6 1.544 0 1.29 1.075 2.336 2.4 2.336.611 0 1.169-.223 1.593-.589m6.846.589c.826-1.237 1.161-2.246 1.161-2.246S19.415 5.1 12 5.1q-.624 0-1.2.063m6.6 12.186c-1.377.88-3.15 1.5-5.4 1.464-7.323-.12-9.6-6.737-9.6-6.737s1.058-3.378 4.2-5.433"
    />
  </svg>
);
export default SvgEyeClosed;
